import React from 'react';
import { useTranslation } from 'react-i18next';

const CapIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" className="h-7 w-7">
    <path d="M22 10 12 5 2 10l10 5 10-5Z" />
    <path d="M6 12v5c0 1 2.5 2.5 6 2.5s6-1.5 6-2.5v-5" />
    <path d="M22 10v6" />
  </svg>
);

const Education = () => {
  const { t } = useTranslation();

  const degrees = [
    { year: t('education.degree1Year'), title: t('education.degree1Title'), school: t('education.degree1School') },
    { year: t('education.degree2Year'), title: t('education.degree2Title'), school: t('education.degree2School') },
    { year: t('education.degree3Year'), title: t('education.degree3Title'), school: t('education.degree3School') },
  ];

  return (
    <section className="bg-white py-20 lg:py-28" id="education">
      <div className="container-x">
        <div className="max-w-2xl" data-aos="fade-up">
          <span className="eyebrow">{t('education.eyebrow')}</span>
          <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-ink">{t('education.title')}</h2>
          <p className="mt-4 text-slatex-600">{t('education.subtitle')}</p>
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-aos="fade-up" data-aos-delay="150">
          {degrees.map((d, i) => (
            <div key={d.title} className="group relative overflow-hidden rounded-2xl border border-slatex-200 bg-white p-7 shadow-soft transition-all duration-300 hover:-translate-y-1 hover:shadow-card" data-aos="fade-up" data-aos-delay={i * 100}>
              <div className="pointer-events-none absolute -right-6 -top-8 h-28 w-28 rounded-full bg-brand-50 blur-2xl" />
              <div className="relative flex items-center justify-between">
                <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-brand-500 to-brand-700 text-white shadow-soft transition-transform duration-300 group-hover:scale-105">
                  <CapIcon />
                </span>
                <span className="rounded-full bg-brand-50 px-3 py-1 text-xs font-bold text-brand-700">{d.year}</span>
              </div>
              <h3 className="relative mt-5 text-lg font-bold text-ink font-display leading-snug">{d.title}</h3>
              <p className="relative mt-1.5 text-sm text-slatex-600">{d.school}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;
